export const StepToScreen = {
  1: 'borrowers',
  2: 'additional',
  3: 'property',
  4: 'declarations',
  5: 'demographic'
};
//# sourceMappingURL=types.js.map